type ChartAxisTickProps = {
  x: number;
  y: number;
  payload: { value: string };
  tickFormatter?: (value: string) => string;
};

export const ChartXAxisTick = ({ x, y, payload, tickFormatter }: ChartAxisTickProps) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={32}
        textAnchor="middle"
        fill="rgb(var(--colors-base-text-quaternary) / var(--tw-text-opacity))"
        className="text-caption-xss-a"
      >
        {tickFormatter ? tickFormatter(payload.value) : payload.value}
      </text>
    </g>
  );
};
